import clsx from "clsx";
import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { FormProvider, useForm } from "react-hook-form";
import { FieldConfig } from "~/components/Forms/DealerPassportForm2/types";
import DynamicFormField from "~/components/Forms/DealerPassportForm2/UI/DynamicFormField";
import { useTranslation } from "react-i18next";
import {
  getDealerGuideDirector,
  getDealerGuide,
} from "~/components/Forms/DealerPassportForm2/Guide/options";
import useGetGuide from "~/components/Forms/DealerPassportForm2/hook/useGetGuide";
import useUpdateGuide from "~/components/Forms/DealerPassportForm2/hook/useUpdateGuide";
import s from "./Guide.less";
import FileLoader from "~/components/FileLoader";
import Button from "~/shared/ui/Fields/Button";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAddNotificationMutation } from "~/schemas/generated/graphql";
import { NOTIFICATIONS } from "~/constans/notifications";

interface GuideProps {
  DealerId: string;
  idArchive?: string;
  allDisabled?: boolean;
}

const checkMailGroup = (val?: string | null): boolean => {
  if (!val) return true;

  const emailList = val
    .split(/[;,]\s*/g)
    .map((e) => e.trim())
    .filter(Boolean);

  return emailList.every((email) =>
    /^[\w.-]+@[\w.-]+\.[A-Za-z]{2,}$/.test(email)
  );
};

const Guide = ({ DealerId, idArchive, allDisabled }: GuideProps) => {
  const { t } = useTranslation();
  const isRu = localStorage.getItem("language") === "ru";
  const dealerGuideDirector = getDealerGuideDirector(t, "director");
  const dealerGuideAccountant = getDealerGuide(t, "accountant");
  const dealerGuideLada = getDealerGuide(t, "lada");
  const {
    data: dataDealer,
    isFetching: isLoadingDealer,
    refetch,
  } = useGetGuide(DealerId);
  const { mutate: updateGuide, isLoading: isUpdating } = useUpdateGuide();
  const [addNotificationMutation] = useAddNotificationMutation({});

  const formResolver = yup.object().shape({
    directorname: yup.string().nullable(),
    directornameGenitive: yup.string().nullable(),
    directorposition: yup.string().nullable(),
    directorpositionGenitive: yup.string().nullable(),
    directorcode: yup.string().nullable(),
    directorfax: yup.string().nullable(),
    directorphone: yup.string().nullable(),
    directormphone: yup.string().nullable(),
    directoremail: yup.string().nullable(),
    // .max(250, t("validation.more250"))
    // .test(
    //     "Email group check",
    //     t("validation.invalid_email"),
    //     checkMailGroup
    // ),
    accountantname: yup.string().nullable(),
    accountantcode: yup.string().nullable(),
    accountantphone: yup.string().nullable(),
    accountantfax: yup.string().nullable(),
    accountantemail: yup.string().nullable(),
    // .max(250, t("validation.more250"))
    // .test(
    //     "Email group check",
    //     t("validation.invalid_email"),
    //     checkMailGroup
    // ),
    // ladaname: yup.string().nullable().required(t("validation.required")),
    ladacode: yup.string().nullable(),
    ladaphone: yup.string().nullable(),
    ladafax: yup.string().nullable(),
    ladaemail: yup.string().nullable(),
    // .max(250, t("validation.more250"))
    // .test(
    //     "Email group check",
    //     t("validation.invalid_email"),
    //     checkMailGroup
    // ),
  });

  const method = useForm({
    defaultValues: {
      guide: { photo: null },
      directorname: "",
      directornameGenitive: "",
      directorphone: "",
      directormphone: "",
      directoremail: "",
      directorfax: "",
      directorcode: "",
      directorposition: "",
      directorpositionGenitive: "",
      directorpositionImported: "",
      directortermOfAuthority: "",
      accountantname: "",
      accountantcode: "",
      accountantphone: "",
      accountantfax: "",
      accountantemail: "",
      ladaname: "",
      ladacode: "",
      ladaphone: "",
      ladafax: "",
      ladaemail: "",
      ScanBossPersonDataId: null,
      ScanAccountantPersonDataId: null,
      ScanLadaPersonDataId: null,
    },
    mode: "onChange",
    resolver: yupResolver(formResolver),
  });

  console.log(method.errors, "method.errors");

  useEffect(() => {
    if (dataDealer) {
      const defaultValues = {
        guide: {
          photo: dataDealer.director?.photo?.link
            ? dataDealer.director.photo
            : null,
        },
        directorname: dataDealer.director?.name || "",
        directornameGenitive: dataDealer.director?.nameGenitive || "",
        directorphone: dataDealer.director?.phone || "",
        directormphone: dataDealer.director?.mphone || "",
        directoremail: dataDealer.director?.email || "",
        directorfax: dataDealer.director?.fax || "",
        directorcode: dataDealer.director?.code || "",
        directorposition: dataDealer.director?.position || "",
        directorpositionGenitive: dataDealer.director?.positionGenitive || "",
        directorpositionImported: dataDealer.director?.positionImported || "",
        directortermOfAuthority: dataDealer.director?.termOfAuthority || "",
        accountantname: dataDealer.accountant?.name || "",
        accountantcode: dataDealer.accountant?.code || "",
        accountantphone: dataDealer.accountant?.phone || "",
        accountantfax: dataDealer.accountant?.fax || "",
        accountantemail: dataDealer.accountant?.email || "",
        ladaname: dataDealer.ladaResponsible?.name || "",
        ladacode: dataDealer.ladaResponsible?.code || "",
        ladaphone: dataDealer.ladaResponsible?.phone || "",
        ladafax: dataDealer.ladaResponsible?.fax || "",
        ladaemail: dataDealer.ladaResponsible?.email || "",
        ScanBossPersonDataId: dataDealer.director?.scan || null,
        ScanAccountantPersonDataId: dataDealer.accountant?.scan || null,
        ScanLadaPersonDataId: dataDealer.ladaResponsible?.scan || null,
      };

      method.reset(defaultValues);
      method.register("ScanBossPersonDataId");
      method.register("ScanAccountantPersonDataId");
      method.register("ScanLadaPersonDataId");
    }
  }, [dataDealer]);

  const onSubmit = (data: any) => {
    const formattedData = {
      id: parseInt(DealerId, 10),
      director: {
        name: data.directorname || "",
        nameGenitive: data.directornameGenitive || "",
        phone: data.directorphone || "",
        mphone: data.directormphone || "",
        email: data.directoremail || "",
        fax: data.directorfax || "",
        code: data.directorcode || "",
        position: data.directorposition || "",
        positionGenitive: data.directorpositionGenitive || "",
        positionImported: data.directorpositionImported || "",
        termOfAuthority: data.directortermOfAuthority || "",
        ...(data.guide?.photo
          ? {
              photo:
                typeof data.guide?.photo === "object"
                  ? data.guide?.photo.id
                  : Number(data.guide?.photo),
            }
          : { photo: null }),
        ...(data.ScanBossPersonDataId
          ? {
              scan:
                typeof data.ScanBossPersonDataId === "object"
                  ? data.ScanBossPersonDataId.id
                  : Number(data.ScanBossPersonDataId),
            }
          : { scan: null }),
      },
      accountant: {
        name: data.accountantname || "",
        code: data.accountantcode || "",
        phone: data.accountantphone || "",
        fax: data.accountantfax || "",
        email: data.accountantemail || "",
        ...(data.ScanAccountantPersonDataId
          ? {
              scan:
                typeof data.ScanAccountantPersonDataId === "object"
                  ? data.ScanAccountantPersonDataId.id
                  : Number(data.ScanAccountantPersonDataId),
            }
          : { scan: null }),
      },
      ladaResponsible: {
        name: data.ladaname || "",
        code: data.ladacode || "",
        phone: data.ladaphone || "",
        fax: data.ladafax || "",
        email: data.ladaemail || "",
        ...(data.ScanLadaPersonDataId
          ? {
              scan:
                typeof data.ScanLadaPersonDataId === "object"
                  ? data.ScanLadaPersonDataId.id
                  : Number(data.ScanLadaPersonDataId),
            }
          : { scan: null }),
      },
    };

    updateGuide(
      { dealerId: DealerId, data: formattedData },
      {
        onSuccess: () => {
          addNotificationMutation({
            variables: {
              type: NOTIFICATIONS.success,
              content: t("common.сhange_was_successful"),
            },
          });
          refetch();
        },
        onError: (error) => {
          console.error("Error updating guide:", error);
        },
      }
    );
  };

  const deleteScan = (key: string) => {
    method.setValue(key, null);
    method.register(key);
  };

  const guidePhotoWatch = method.watch("guide.photo");
  const accessToEditField = (
      fieldName: string,
      currentFieldName: string,

  ) => {
    if (
        allDisabled &&
        fieldName === currentFieldName
    ) {
      return false;
    }
    return true;
  };
  if (isLoadingDealer) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <FormProvider {...method}>
        <form
          onSubmit={method.handleSubmit(onSubmit)}
          className={clsx("dynamic-form")}
        >
          <div className={s.wrapper}>
            <div className={s.wrap}>
              <div
                className={clsx(s.wrapperDealerImg, {
                  [s.imgActive]: !!guidePhotoWatch,
                })}
              >
                {dataDealer && (
                  <FileLoader
                    name="guide.photo"
                    withIMG
                    isNewStyle
                    isNoneUpload={!!idArchive}
                    deleteFile={() => deleteScan("guide.photo")}
                    download={dataDealer.director?.photo || null}
                    control={method.control}
                    setValue={method.setValue}
                    disabled={allDisabled}
                  />
                )}
              </div>

              <div className={s.wrapperRight}>
                <div className={s.wrapperBase}>
                  <div className={s.title}>Руководитель</div>
                  <div>
                    {dealerGuideDirector.map((field) => (
                      <DynamicFormField
                        key={field.name}
                        {...field}
                        name={field.name}
                        // disabled={true || allDisabled}
                        disabled={accessToEditField(
                          field.name,
                          "directormphone",
                        )}
                      />
                    ))}
                  </div>
                  <FileLoader
                    name="ScanBossPersonDataId"
                    withButton
                    isNewStyleScan
                    isNoneUpload={!!idArchive}
                    label={t("ui.download_title_scan_boss")}
                    // download={dataDealer?.director?.scan}
                    download={method.getValues("ScanBossPersonDataId")}
                    titleDownload={t("ui.title_scan_boss")}
                    control={method.control}
                    setValue={method.setValue}
                    deleteFile={() => deleteScan("ScanBossPersonDataId")}
                    disabled={allDisabled}
                  />
                </div>
                <div className={s.wrapperBase1}>
                  <div className={s.title}>Бухгалтер</div>
                  <div>
                    {dealerGuideAccountant.map((field) => (
                      <DynamicFormField
                        key={field.name}
                        {...field}
                        name={field.name}
                        disabled={true || allDisabled}
                      />
                    ))}
                  </div>
                  <FileLoader
                    name="ScanAccountantPersonDataId"
                    withButton
                    isNewStyleScan
                    isNoneUpload={!!idArchive}
                    label={t("ui.download_title_scan_accounting")}
                    // download={dataDealer?.accountant?.scan}
                    download={method.getValues("ScanAccountantPersonDataId")}
                    titleDownload={t("ui.title_scan_accounting")}
                    control={method.control}
                    setValue={method.setValue}
                    disabled={allDisabled}
                    deleteFile={() => deleteScan("ScanAccountantPersonDataId")}
                  />
                </div>
                <div className={s.wrapperBase1}>
                  <div className={s.title}>Ответственный за бренд LADA</div>
                  <div>
                    {dealerGuideLada.map((field) => (
                      <DynamicFormField
                        key={field.name}
                        {...field}
                        name={field.name}
                        disabled={true || allDisabled}
                      />
                    ))}
                  </div>
                  <FileLoader
                    name="ScanLadaPersonDataId"
                    withButton
                    isNewStyleScan
                    isNoneUpload={!!idArchive}
                    label={t("ui.download_title_scan_lada")}
                    // download={dataDealer?.ladaResponsible?.scan}
                    download={method.getValues("ScanLadaPersonDataId")}
                    titleDownload={t("ui.title_scan_lada")}
                    control={method.control}
                    setValue={method.setValue}
                    disabled={allDisabled}
                    deleteFile={() => deleteScan("ScanLadaPersonDataId")}
                  />
                </div>
                <div className={s.wrapperBTN}>
                  {!allDisabled && (
                    <Button
                      txtBtn={"Сохранить изменения"}
                      orange
                      isForm
                      customClassName={s.but}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

export default Guide;
